<template>
  <b-overlay :show="loading">
    <b-row>
      <b-col lg="4" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/penjualan')" icon="ShoppingCartIcon" color="primary" :statistic="cardPenjualan" statistic-title="Total Penjualan" />
      </b-col>
      <b-col lg="4" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/kendaraan-barang')" icon="BoxIcon" color="success" :statistic="cardStokBarang" statistic-title="Stok Barang (Mobil)" />
      </b-col>
      <b-col lg="4" sm="6">
        <statistic-card-horizontal @onClick="$router.push('/collection')" icon="FileIcon" color="warning" :statistic="cardCollection" statistic-title="Collection" />
      </b-col>
      <b-col cols="12">
        <sales-graphic />
      </b-col>
      <br />
      <br />
    </b-row>
  </b-overlay>
</template>
<script>
import { BAlert } from "bootstrap-vue";
import { BOverlay, BFormGroup, BButton, BFormInput, BTabs, BTab, BRow, BCol, BCard } from "bootstrap-vue";
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue";
import AppEchartBar from "@core/components/charts/echart/AppEchartBar.vue";
import AppEchartDoughnut from "@core/components/charts/echart/AppEchartDoughnut.vue";
import AppEchartLine from "@core/components/charts/echart/AppEchartLine.vue";
import SalesGraphic from './_penjualan.vue'
export default {
  data() {
    return {
      filter: {
        tgl_awal: null,
        tgl_akhir: null
      },
      dataPenjualan: {},
      card: {},
      dataChartBar: {
        xAxis: {
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            type: "bar",
            data: [],
          },
        ],
      },

      dataChartLine: {
        xAxisData: ["Satu", "Dua", "Tiga", "Empat", "Lima", "Enam"],
        series: [23000, 40000, 30000, 60000, 10000, 40000],
      },
      loading: false
    };
  },
  components: {
    BOverlay,
    SalesGraphic,
    StatisticCardHorizontal,
    BAlert,
    BFormInput,
    BTabs,
    BTab,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BCard,
    AppEchartBar,
    AppEchartDoughnut,
    AppEchartLine,
  },
  computed: {
    myName() {
      if (this.user) {
        return this.user.karyawan ? this.user.karyawan.nama_lengkap : this.user.email;
      }

      return null;
    },
    cardPenjualan() {
      return "Rp " + this.formatRupiah(this.card.penjualan);
    },
    cardStokBarang() {
      return "Rp " + this.formatRupiah(this.card.barangMobilNilai);
    },
    cardCollection() {
      return "Rp " + this.formatRupiah(this.card.collection);
    },
  },
  methods: {
    postCardInfo() {
      let payload = {
        show: {
          penjualan: true,
          sales: true,
          karyawan: true,
          collection: true,
          assetTotal: true,
          assetNilai: true,
          barangMobilNilai: true,
          keuntungan: true,
        },
        setting: {
          penjualan: {
            id_sales: this.user.karyawan.id,
          },
          barangMobilNilai: {
            id_sales: this.user.karyawan.id
          },
          collection: {
            id_sales: this.user.karyawan.id
          }
        },
      };

      this.$store
        .dispatch("dashboard/cardInfo", payload)
        .then((res) => {
          this.card = res;
        })
        .catch((e) => console.error(e));
    },
  },

  mounted() {
    this.postCardInfo();
  },
};
</script>
